import React from 'react';
import { Box, Typography } from '@mui/material';

const StatusCodes: React.FC = () => {
    const statusCategories = [
        {
            category: '2XX - Success of some kind',
            color: '#82eca8ff',
            codes: [
                { code: '200', description: 'OK' },
                { code: '201', description: 'Created' }
            ]
        },
        {
            category: '4XX - Error occurred in client\'s part',
            color: '#f9c975ff',
            codes: [
                { code: '400', description: 'Bad request' },
                { code: '401', description: 'Authentication failure' },
                { code: '403', description: 'Forbidden' },
                { code: '404', description: 'Resource not found' }
            ]
        },
        {
            category: '5XX - Error occurred in server\'s part',
            color: '#ef4444',
            codes: [
                { code: '500', description: 'Internal Server Error' },
                { code: '501', description: 'Not Implemented' },
                { code: '503', description: 'Service Unavailable' }
            ]
        }
    ];

    return (
        <Box className="flex flex-col border-b border-gray-200" id="status-codes">
            <Typography variant="h6" fontWeight={600} fontSize={16} mb={1}>
                STATUS CODES
            </Typography>
            
            <Typography variant="body2" fontSize={14} fontWeight={400} mb={2}>
                All status codes are standard HTTP status codes. The below ones are used in this API.
            </Typography>
            <Box sx={{ 
                backgroundColor: '#35353eff',
                border: '1px solid #45475a',
                borderRadius: 2,
                overflow: 'hidden',
                marginBottom: 2
            }}>
                <Box sx={{ 
                    backgroundColor: '#35353eff',
                    borderBottom: '1px solid #45475a',
                    px: 2,
                    py: 1
                }}>
                    <Typography 
                        variant="body2" 
                        fontSize={12}
                        sx={{ 
                            color: '#e32f62ff',
                            fontWeight: 600
                        }}
                    >
                        NOTE
                    </Typography>
                </Box>
                <Box sx={{ padding: 2 }}>
                    <Typography variant="body2" fontSize={12} sx={{ color: '#cdd6f4' }}>
                        If your token becomes invalid, you need to call the authenticate API which is mentioned above to get a fresh token.
                    </Typography>
                </Box>
            </Box>

            {/* Status Categories */}
            {statusCategories.map((category, categoryIndex) => (
                <Box key={categoryIndex} sx={{ marginBottom: 2 }}>
                    <Typography variant='body2' marginBottom={1} fontSize={14} fontWeight={600}>
                        {category.category}
                    </Typography>
                    
                    <Box sx={{ 
                        backgroundColor: '#3a3a42ff',
                        border: '1px solid #45475a',
                        borderRadius: 2,
                        overflow: 'hidden'
                    }}>
                        <Box sx={{ 
                            backgroundColor: '#3d3d46ff',
                            borderBottom: '1px solid #45475a',
                            px: 2,
                            py: 1,
                            display: 'flex'
                        }}>
                            <Typography 
                                variant="body2" 
                                fontSize={12}
                                sx={{ 
                                    color: '#a6adc8',
                                    fontWeight: 500,
                                    flex: '0 0 100px'
                                }}
                            >
                                Status Code
                            </Typography>
                            <Typography 
                                variant="body2" 
                                fontSize={12}
                                sx={{ 
                                    color: '#a6adc8',
                                    fontWeight: 500,
                                    flex: 1
                                }}
                            >
                                Description
                            </Typography>
                        </Box>

                        {category.codes.map((statusCode, index) => (
                            <Box 
                                key={index}
                                sx={{ 
                                    display: 'flex',
                                    borderBottom: index < category.codes.length - 1 ? '1px solid #45475a' : 'none',
                                    minHeight: 44,
                                    alignItems: 'center',
                                    '&:hover': { backgroundColor: '#42424bff' },
                                    transition: 'background-color 0.2s ease',
                                    px: 2,
                                    py: 1
                                }}
                            >
                                <Box sx={{ flex: '0 0 100px' }}>
                                    <Typography 
                                        variant="body2" 
                                        fontSize={12}
                                        sx={{ 
                                            color: category.color,
                                            fontFamily: 'monospace',
                                            fontWeight: 600,
                                            backgroundColor: '#3b3b45ff',
                                            padding: '4px 8px',
                                            borderRadius: '4px',
                                            display: 'inline-block',
                                            minWidth: '40px',
                                            textAlign: 'center'
                                        }}
                                    >
                                        {statusCode.code}
                                    </Typography>
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography 
                                        variant="body2" 
                                        fontSize={12}
                                        sx={{ 
                                            color: '#cdd6f4',
                                            fontWeight: 500
                                        }}
                                    >
                                        {statusCode.description}
                                    </Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default StatusCodes;
